<!-- Client participation checkbox -->
@if (showClientToggle()) {
	<lvr-field>
		<mat-checkbox
			lvrPadding
			[padVertical]="16"
			[padHorizontal]="20"
			[checked]="isClientParticipant()"
			(change)="toggleClientAsParticipant()"
		>
			{{ 'base.field.client_participated' | transloco }}
		</mat-checkbox>
	</lvr-field>
}

<lvr-field [label]="label()">
	<mat-form-field lvrInput [attr.aria-label]="label()">
		<input
			#participantInput
			type="text"
			matInput
			[disabled]="isDisabled()"
			[placeholder]="'base.field.name_search_placeholder' | transloco"
			[matAutocomplete]="auto"
			(input)="updateTerm($event)"
			(blur)="onBlur()"
			(focus)="onFocus()"
			(click)="onFocus()"
		/>
	</mat-form-field>

	<mat-autocomplete #auto="matAutocomplete" (optionSelected)="onOptionSelected($event)" [autoActiveFirstOption]="false">
		@for (key of resultsGrouped().keys(); track key) {
			<mat-optgroup [label]="translatePersonType(key) | transloco">
				@for (option of resultsGrouped().get(key); track option.item.id) {
					<mat-option [value]="option">
						<lvr-participant-item
							[option]="option"
							[selected]="option.selected"
							[showCheckbox]="showCheckbox()"
							[specialization]="specializationFor(option)"
						/>
					</mat-option>
				}
			</mat-optgroup>
		}

		@if (searchResults().length === 0 && !searching() && searchTerm().length >= 2) {
			<mat-option disabled>
				{{ 'base.field.no_participants_found' | transloco }}
			</mat-option>
		}
	</mat-autocomplete>
</lvr-field>

<section>
	@if (selected.length > 0) {
		@for (participant of selected; track trackItem(participant)) {
			<lvr-participant-item
				[selected]="true"
				[option]="participant"
				[showCheckbox]="showCheckbox()"
				[specialization]="specializationFor(participant)"
				(selectionChanged)="onSelect($event)"
			/>

			@if (typeOfContact() && isContactTypeAnEmail()) {
				@let emailList = emails(participant);

				@if (emailList.length > 0) {
					<ul class="contact-points">
						@for (cp of emailList; track cp.id) {
							<li>
								<div class="contact-way-info">
									<span class="contact-value">{{ cp.contactValue }}</span>
									<span class="remark">{{ cp.remark }}</span>
									<span class="remark">{{
										cp.preferredWayOfContact ? ('base.field.group.preferred_contact_type' | transloco) : ''
									}}</span>
								</div>
								@if (showEmailSendButton()) {
									<lvr-send-email-button
										[participantName]="participant.item.firstName + ' ' + participant.item.name"
										[subject]="subject() ?? ''"
										[body]="body() ?? ''"
										[contactPoints]="[cp]"
									></lvr-send-email-button>
								}
							</li>
						}
					</ul>
				} @else {
					<span class="no-contact-points">{{ 'base.field.participant_no_email' | transloco }}</span
					><br />
					<span class="no-contact-points">{{ 'base.field.participant_add_communication_way' | transloco }}</span>
				}
			}
		}
	}
</section>
